__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/2776614de3caf63387f492e142da674c833c9667/_next/";